import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyDanoneMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="danoneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#0077BE", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#64CCC9", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#E8F5E9", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#danoneGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 20 }).map((_, r) => (
          <circle
            key={`circular-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 20}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 4 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.01}
          />
        ))}
        {Array.from({ length: 12 }).map((_, wave) => {
          const points: string[] = [];
          const y = -400 + wave * 68;
          for (let p = 0; p <= 40; p++) {
            const t = p / 40;
            const x = -360 + t * 720;
            const yOffset = Math.sin(t * Math.PI * 3) * 25;
            points.push(`${x},${y + yOffset}`);
          }
          return (
            <polyline
              key={`water-${wave}`}
              points={points.join(" ")}
              fill="none"
              stroke="#64CCC9"
              strokeWidth={2}
              opacity={0.25}
            />
          );
        })}
        <circle cx={0} cy={0} r={55} fill="none" stroke="#64CCC9" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={38} fill="#0077BE" opacity={0.3} />
      </g>
    </svg>
  );
};
